import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import NotificationsContext from './context';

import { useInterval } from '../../hooks/useInterval';
import {
  DEVELOPER_ROLE,
  STATUS_PENDING,
} from '../../assets/AppConstants';

import { useAppContext } from '../app';
import { useUserContext } from '../user';
import { getNotificationsRefresh } from '../../services/Notifications';
import { useWorkspaceContext } from '../workspace';

const NotificationsContextProvider = ({ children }) => {
  const {
    userSession,
    userIsLogged,
    getUserStatus,
  } = useUserContext();

  const {
    hasRequestStatus,
  } = useAppContext();
  const {
    workspace: {
      defaultWorkspace,
      getWorkspaceRole,
    },
  } = useWorkspaceContext();
  const [newNotifications, setNewNotifications] = useState(0);

  const reloadNotifications = async () => {
    const hasWorkspaceUserRole = userIsLogged() && defaultWorkspace?.currentUser?.role;
    const userIsPending = getUserStatus() === STATUS_PENDING;
    const userIsDeveloper = getWorkspaceRole() === DEVELOPER_ROLE;

    const canReloadNotifications = (
      hasWorkspaceUserRole && !userIsPending && !userIsDeveloper && !hasRequestStatus()
    );

    if (!canReloadNotifications) return;

    try {
      const unreadNotifications = await getNotificationsRefresh({ page: 0, onlyUnread: true });
      setNewNotifications(unreadNotifications?.totalElements);
    } catch (_error) {
      //handleAlert(error, 'error');
    }
  };

  useEffect(() => {
    reloadNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession, defaultWorkspace]);

  useInterval(() => {
    reloadNotifications();
  }, 20000);

  const notificationsValue = useMemo(() => ({
    newNotifications,
    changeNewNotifications: setNewNotifications,
  }), [newNotifications]);

  return (
    <NotificationsContext.Provider value={notificationsValue}>
      {children}
    </NotificationsContext.Provider>
  );
};

NotificationsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NotificationsContextProvider;
